import { ref, onMounted, onUnmounted, computed } from "vue";

export function mobileUtil() {
    const windowWidth = ref(window.innerWidth);

    const onResize = () => {
        windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
        window.addEventListener("resize", onResize);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", onResize);
    });

    const isMobile = computed(() => {
        return windowWidth.value <= 770;
    });

    const isPhone = computed(() => {
        return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    });

    const isAndroid = computed(() => {
        return /Android/i.test(navigator.userAgent);
    });

    const isIos = computed(() => {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    });

    const appLink = computed(() => {
        if (isAndroid.value) {
            return "https://play.google.com/store/apps/details?id=io.dateit.app.android";
        }
        return "https://apps.apple.com/us/app/dateit/id1610780514";
    });

    const navigateToApp = () => {
        window.location.href = appLink.value;
    };

    const isEmbeddedBrowser = computed(() => {
        return navigator.userAgent.includes("FBAN") || navigator.userAgent.includes("FBAV") || navigator.userAgent.includes("Bytedance") || navigator.userAgent.includes("Snapchat") || navigator.userAgent.includes("LinkedInApp") || navigator.userAgent.includes("WhatsApp") || navigator.userAgent.includes("Instagram");
    });

    return {
        isMobile,
        isPhone,
        isAndroid,
        isIos,
        appLink,
        navigateToApp,

        isEmbeddedBrowser,
    };
}
